import React from 'react';
import s from './style.css';
const ProgressBar = (props) => {
    const progress = Math.max(0.01, props.progress);
    const maxWidth = 160;
    const filledWidth = maxWidth * progress;
    const emptyWidth = maxWidth - filledWidth;
    return (React.createElement("div", { className: s.container },
        React.createElement("div", { className: s.filled, style: { width: `${filledWidth}px` } }),
        React.createElement("div", { className: s.empty, style: { width: `${emptyWidth}px` } })));
};
export default ProgressBar;
